var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, forwardRef, useRef, useEffect } from "react";
import { Container } from "../../technical-fundamental";
import { ModalV2, ModalV2Content, ModalV2Title } from "../Modal";
import Button from "../Button/Button";
var Transcription = forwardRef(function (_a, ref) {
    var id = _a.id, children = _a.children, modalTitle = _a.modalTitle, _b = _a.defaultExpanded, defaultExpanded = _b === void 0 ? false : _b, className = _a.className, style = _a.style, otherProps = __rest(_a, ["id", "children", "modalTitle", "defaultExpanded", "className", "style"]);
    var _c = useState(defaultExpanded), isExpanded = _c[0], setIsExpanded = _c[1];
    var _d = useState(false), isModalOpen = _d[0], setIsModalOpen = _d[1];
    var enlargeButtonRef = useRef(null);
    var collapseRef = useRef(null);
    var idCollapse = "fr-transcription-collapse-".concat(id);
    var idModal = "fr-transcription-modal-".concat(id);
    var idModalTitle = "fr-transcription-modal-".concat(id, "-title");
    var handleToggleCollapse = function () {
        setIsExpanded(function (prevState) { return !prevState; });
    };
    var handleOpenModal = function () {
        setIsModalOpen(true);
    };
    var handleCloseModal = function () {
        setIsModalOpen(false);
        if (enlargeButtonRef.current) {
            enlargeButtonRef.current.focus();
        }
    };
    useEffect(function () {
        if (collapseRef.current) {
            collapseRef.current.style.setProperty("--collapser", "none");
            var height = collapseRef.current.offsetHeight;
            collapseRef.current.style.setProperty("--collapse", "-".concat(height, "px"));
            collapseRef.current.style.setProperty("--collapser", "");
        }
    }, [collapseRef]);
    return (React.createElement("div", __assign({}, otherProps, { id: id, ref: ref, style: style, className: "fr-transcription ".concat(className ? className : "") }),
        React.createElement("button", { className: "fr-transcription__btn", "aria-expanded": isExpanded, "aria-controls": idCollapse, onClick: handleToggleCollapse, type: "button" }, "Transcription"),
        React.createElement("div", { ref: collapseRef, className: "fr-collapse ".concat(isExpanded ? "fr-collapse--expanded" : ""), id: idCollapse, style: { "--collapse-max-height": "none" } },
            React.createElement("div", { className: "fr-transcription__footer" },
                React.createElement("div", { className: "fr-transcription__actions-group" },
                    React.createElement(Button, { ref: enlargeButtonRef, className: "fr-btn--fullscreen", "aria-controls": idModal, "aria-label": "Agrandir la transcription", onClick: handleOpenModal }, "Agrandir"))),
            React.createElement(Container, { fluid: true, className: "ssg-transcription__content" }, children),
            isModalOpen && (React.createElement(ModalV2, { onClose: handleCloseModal, id: idModal, idModalTitle: idModalTitle, size: "lg" },
                React.createElement(ModalV2Content, null,
                    React.createElement(ModalV2Title, { id: idModalTitle }, modalTitle),
                    children))))));
});
export default Transcription;
